export default __webpack_public_path__ + "2d90da967124ee2fd56b64008f9946e6.svg";